import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import clsx from 'clsx';
import { Lines } from '@/types';
import { PencilColor } from './ColorPicker';
import { CanvasDraw } from './CanvasDraw';

interface CanvasWriteParams {
  className?: string;
  currentColor?: PencilColor;
  fill?: boolean;
  drawWidth?: number;
  drawHeight?: number;
}

export interface CanvasWrite {
  reset: () => void;
  asBitmap: () => string | undefined;
  asVector: () => Lines;
}

export const CanvasWrite = forwardRef<CanvasWrite, CanvasWriteParams>(
  ({ className, currentColor, fill = false, drawWidth, drawHeight }, ref) => {
    const drawRef = useRef<CanvasDraw | null>(null);
    const [outputLines, setOutputLines] = useState<Lines>([]);

    useImperativeHandle(ref, () => ({
      reset: () => {
        drawRef.current?.reset();
      },
      asBitmap: () => drawRef.current?.asBitmap(),
      asVector: () => outputLines,
    }));

    return (
      <div
        className={clsx(className)}
        style={{
          width: drawWidth,
          height: drawHeight,
        }}
      >
        <CanvasDraw
          ref={drawRef}
          currentColor={currentColor}
          fill={fill}
          width={drawWidth}
          height={drawHeight}
          includeBgOnLines={true}
          setOutputLines={setOutputLines}
        />
      </div>
    );
  },
);

CanvasWrite.displayName = 'CanvasWrite';
